document.addEventListener('DOMContentLoaded', function () {
  const brandItems = document.querySelectorAll('.brand-item');
  const brandTrack = document.querySelector('.brand-track');

  brandItems.forEach(item => {
    item.addEventListener('touchstart', function (e) {
      // Baki saare logos ko reset karo
      brandItems.forEach(i => {
        if (i !== item) i.classList.remove('active');
      });

      // Agar click already active nahi hai to scroll pause karo aur color dikhao
      if (!item.classList.contains('active')) {
        e.preventDefault();
        
        // Track ko pause class do taaki animation ruk jaye
        if (brandTrack) brandTrack.classList.add('paused');
        item.classList.add('active');
        
        // Redirect with delay
        setTimeout(() => {
          const link = item.querySelector('.brand-link').getAttribute('href');
          if (link && link !== '#') {
            window.location.href = link;
          }
        }, 400); 
      }
    });
  });

  // Screen par kahi aur touch karne par scroll wapas chalu ho jaye aur color black-white ho jaye
  document.addEventListener('touchstart', function (e) {
    if (!e.target.closest('.brand-item')) {
      brandItems.forEach(item => item.classList.remove('active'));
      if (brandTrack) brandTrack.classList.remove('paused');
    }
  });
});